export { ACTIVITIES as PAY_ACTIVITIES } from "./activities";

export const PAY_KEYS = [
  ["standard", "Standard"], ["night", "Nuit"], ["sunday", "Dimanche"], ["sunday_night", "Nuit dim."],
  ["holiday", "Férié"], ["holiday_night", "Nuit férié"], ["holiday_sunday", "Dim. férié"], ["holiday_sunday_night", "Nuit dim. férié"],
];

export const eur = (n) => (n == null ? "—" : `${Number(n).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`);

const csvCell = (x) => { const t = x == null ? "" : String(x); return /[";\n]/.test(t) ? `"${t.replace(/"/g, '""')}"` : t; };
export const downloadCsv = (filename, header, rows) => {
  const body = [header, ...rows].map((r) => r.map(csvCell).join(";")).join("\r\n");
  const href = URL.createObjectURL(new Blob(["\ufeff" + body], { type: "text/csv;charset=utf-8" }));
  Object.assign(document.createElement("a"), { href, download: filename }).click();
  setTimeout(() => URL.revokeObjectURL(href), 2000);
};
